import {gql} from 'apollo-angular';

export function retrievePopById(fields: string[]) {
  return gql`
      query retrievePopById($id: String!) {
          retrievePopById(id: $id) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function retrievePopsByUserId(fields: string[]) {
  return gql`
      query retrievePopsByEmployeeId($employeeId: String!, $page: Int!, $size: Int!) {
          retrievePopsByEmployeeId(employeeId: $employeeId, page: $page, size: $size) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function retrieveAllPopsByUserId(fields: string[]) {
  return gql`
      query retrieveAllPopsByEmployeeId($employeeId: String!) {
          retrieveAllPopsByEmployeeId(employeeId: $employeeId) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function createPop(fields: string[]) {
  return gql`
      mutation createPop($pop: ConceptPopDto!) {
          createPop(pop: $pop) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function updatePop(fields: string[]) {
  return gql`
      mutation updatePop($pop: PopDto!) {
          updatePop(pop: $pop) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function retrieveActivePopByEmployeeId(fields: string[]) {
  return gql`
      query retrieveActivePopByEmployeeId($employeeId: String!) {
          retrieveActivePopByEmployeeId(employeeId: $employeeId) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function removePop() {
  return gql`
      mutation removePop($popId: String!) {
          removePop(popId: $popId)
      }
  `;
}

export function retrievePopFeedback(fields: string[]) {
  return gql`
      query retrievePopFeedback($popId: String!) {
          retrievePopFeedback(popId: $popId) {
              ${fields.join('\n')}
          }
      }
  `;
}


export function createPopFeedback(fields: string[]) {
  return gql`
      mutation createPopFeedback($popId: String!, $popFeedback: PopFeedbackDto!) {
          createPopFeedback(popId: $popId, popFeedback: $popFeedback) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function approvePop() {
  return gql`
      mutation approvePop($popId: String!) {
          approvePop(popId: $popId)
      }
  `;
}

export function retrievePopStatusSummary(fields: string[]) {
  return gql`
      query retrievePopStatusSummary {
          retrievePopStatusSummary {
              ${fields.join('\n')}
          }
      }
  `;
}

export function submitPopFeedbackRequest() {
  return gql`
      mutation submitPopFeedbackRequest($popId: String!, $feedbacks: [PopFeedbackDto!]!, $feedbackExpiryDate: Date!) {
          submitPopFeedbackRequest(popId: $popId, feedbacks: $feedbacks, feedbackExpiryDate: $feedbackExpiryDate)
      }
  `;
}

export function updatePopFeedbackExpiryDate() {
  return gql`
      mutation updatePopFeedbackExpiryDate($popId: String!, $feedbackExpiryDate: Date!, $isSelfReflection: Boolean!) {
          updatePopFeedbackExpiryDate(popId: $popId, feedbackExpiryDate: $feedbackExpiryDate, isSelfReflection: $isSelfReflection)
      }
  `;
}
